// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faDatabase)

const FaDatabase = props => (
  <FontAwesomeIcon
    {...props}
    icon={'database'} />
)

export default FaDatabase
